import React from "react"

import { Button, ButtonProps } from "./Button"

interface ConditionalButtonProps extends ButtonProps {
  isButton?: boolean
}

export const ConditionalButton = React.memo(
  ({ isButton, ...rest }: ConditionalButtonProps) => {
    if (isButton) {
      return <Button {...rest} />
    }
    return <div className={rest.className}>{rest.children}</div>
  }
)
